"use client";

import { useState, useEffect } from "react";
import { getRelatedGames } from "@/lib/games";
import GameGrid from "@/components/game-grid";
import type { GameType } from "@/lib/types";
import "./loading-bar.css"; // CSS 파일 import

interface RelatedGamesProps {
  currentGameId: string;
}

// Windows XP 스타일 로딩 바 컴포넌트
function LoadingBar() {
  return (
    <div className="loading-container">
      <div className="loading-bar">
        <div className="progress"></div>
      </div>
    </div>
  );
}

export function RelatedGames({ currentGameId }: RelatedGamesProps) {
  const [relatedGames, setRelatedGames] = useState<GameType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRelatedGames = async () => {
      setLoading(true);
      setError(null);
      try {
        const relatedGamesData = await getRelatedGames(currentGameId);
        setRelatedGames(relatedGamesData);
      } catch (err) {
        console.error("관련 게임 데이터 로딩 실패:", err);
        setError("관련 게임 데이터를 불러오는 데 실패했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchRelatedGames();
  }, [currentGameId]);

  if (loading) {
    return (
      <section className="mt-8">
        <h2 className="text-xl font-bold mb-4">관련 게임</h2>
        <LoadingBar />
      </section>
    );
  }

  if (error) {
    return (
      <section className="mt-8">
        <h2 className="text-xl font-bold mb-4">관련 게임</h2>
        <div className="text-center text-red-500">
          <p>{error}</p>
        </div>
      </section>
    );
  }

  if (relatedGames.length === 0) {
    return null;
  }

  return (
    <section className="mt-8">
      <h2 className="text-xl font-bold mb-4">관련 게임</h2>
      <GameGrid
        games={relatedGames}
        categories={[]}
        selectedCategory={null}
        expandable={false}
        unit={12}
      />
    </section>
  );
}
